export const AddMetadataLabelFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AddMetadataLabelFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DocumentMetadataProperty' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                ],
            },
        },
    ],
};
